module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"username":"User name","user":"user","send":"Send","cancel":"Cancel"},"fr":{"username":"Utilisateur","user":"Utilisateur","send":"Envoyer","cancel":"Annuler"}}')
  delete Component.options._Ctor
}
